const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  searchX3g1Group ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/synchro/search-x3g1-group', {params})
  },
  // 新冠快篩记录查询
  searchPtytkits ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/synchro/search-ptytkits', {params})
  },
  batchConfirmDeclFile ({ state, commit, rootState }, params) {
    return rootState.axios.post('/cc/v1frontend/synchro/batch-confirm-decl-file', params)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cc/synchro.js